import AddCrewMember from "./addCrewMember";
import AllCrewMembers from "./AllCrewMembers";

function CrewMembers() {
  return (
    <>
      <AddCrewMember />
      <AllCrewMembers />
    </>
  );
}


export default CrewMembers